var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  fromJsonData: () => fromJsonData
});
module.exports = __toCommonJS(stdin_exports);
var import_isObject = __toESM(require("lodash/isObject"));
var import_path = require("../utils/path");
function fromJsonData(rootData, opts = {}) {
  function cvtNode(data, ctx) {
    var _a, _b;
    const ans = { type: "any" };
    if (typeof opts.convertor === "function") {
      const res = opts.convertor(data, ctx);
      if ((0, import_isObject.default)(res))
        return res;
    }
    switch (typeof data) {
      case "number":
        ans.type = "number";
        break;
      case "boolean":
        ans.type = "boolean";
        break;
      case "string":
        ans.type = "string";
        break;
      case "object":
        if (Array.isArray(data)) {
          const arrayItem = (_b = (_a = data[0]) !== null && _a !== void 0 ? _a : data[1]) !== null && _b !== void 0 ? _b : data[2];
          if (arrayItem == null && opts.emptyArray === "error") {
            throw new Error(`\u9047\u5230\u4E86\u7A7A\u6570\u7EC4\uFF0C\u65E0\u6CD5\u8F6C\u6362\uFF1A${ctx.pathPrefix}`);
          }
          ans.type = "array";
          ans.items = cvtNode(arrayItem, Object.assign(Object.assign({}, ctx), { depth: ctx.depth + 1, pathPrefix: (0, import_path.joinPath)([ctx.pathPrefix, 0]) }));
        } else if (!!data) {
          ans.type = "object";
          ans.fields = Object.keys(data).map((id) => {
            const val = data[id];
            if ((typeof val === "undefined" || typeof val === "function") && !opts.keepInvalidFields) {
              return null;
            }
            const subAns = Object.assign({ id }, cvtNode(val, Object.assign(Object.assign({}, ctx), { depth: ctx.depth + 1, pathPrefix: (0, import_path.joinPath)([ctx.pathPrefix, id]) })));
            if (opts.allRequired)
              subAns.required = true;
            return subAns;
          }).filter((x) => !!x);
        }
        break;
    }
    return ans;
  }
  return cvtNode(rootData, {
    pathPrefix: "",
    depth: 0
  });
}
